'use es6';

import { FetchProductInventoryRequestTypes } from '../actions/ProductInventoryActions';
const initialState = {};

const ProductInventory = (state = initialState, {
  type,
  payload
}) => {
  switch (type) {
    case FetchProductInventoryRequestTypes.RECEIVE:
      {
        const {
          data
        } = payload;
        return data;
      }

    default:
      return state;
  }
};

export default ProductInventory;